// extracted by mini-css-extract-plugin
export default {"ant-menu-horizontal":"style_ant-menu-horizontal__6TWon","dropdown":"style_dropdown__2znfL"};